import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable @typescript-eslint/no-floating-promises */

/* eslint-disable promise/catch-or-return */
import { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { createElement, Children } from 'react';
import { omit } from '../../../utils';
import { getIsAdmin } from '../eligibility/getIsAdmin';
import { BILLING, MARKETABLE_CONTACTS_WRITE, TEAM } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import * as AdminModalTypes from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import AdminModal from './AdminModal';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import Raven from 'raven-js';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';

const AdminOnlyWrapper = ({
  adminType = TEAM,
  children,
  modalType = AdminModalTypes.DEFAULT,
  productLine,
  upgradeData,
  onClick,
  canViewNewSeats
}) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [showAdminModal, setShowAdminModal] = useState(false);

  const _isMounted = useRef(true);

  const {
    upgradeProduct,
    apiName
  } = upgradeData;
  const apiNameToUse = canViewNewSeats && apiName ? apiName : UpgradeProductToApiNameMap[upgradeProduct];
  useEffect(() => {
    getIsAdmin(adminType).then(isAdminResponse => {
      if (_isMounted.current) {
        setIsAdmin(isAdminResponse);
      }
    });
  }, [adminType]);
  useEffect(() => {
    return function cleanup() {
      _isMounted.current = false;
    };
  }, []);
  useEffect(() => {
    if (modalType === AdminModalTypes.REQUEST_QUOTE && !productLine) {
      Raven.captureMessage('Error in AdminOnlyWrapper: missing productLine for modalType REQUEST_QUOTE');
    } // keep empty dependency array so that this error only fires once, not on every rerender
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  const handleToggleAdminModal = useCallback(() => {
    if (onClick) onClick();
    setShowAdminModal(!showAdminModal);
  }, [onClick, showAdminModal]);
  const child = Children.only(children);

  if (isAdmin) {
    return child;
  }

  const newProps = omit(Object.assign({}, child.props, {
    onClick: handleToggleAdminModal
  }), 'href');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showAdminModal && /*#__PURE__*/_jsx(AdminModal, {
      apiName: apiNameToUse,
      modalType: modalType,
      onClose: handleToggleAdminModal,
      productLine: modalType === AdminModalTypes.REQUEST_QUOTE ? productLine : undefined,
      upgradeData: upgradeData,
      canViewNewSeats: canViewNewSeats
    }), /*#__PURE__*/createElement(child.type, newProps)]
  });
};

AdminOnlyWrapper.propTypes = {
  adminType: PropTypes.oneOf([BILLING, TEAM, MARKETABLE_CONTACTS_WRITE]).isRequired,
  children: PropTypes.node.isRequired,
  modalType: PropTypes.oneOf(Object.values(AdminModalTypes || {})),
  productLine: PropTypes.oneOf(Object.values(ProductLines)),
  // only required for modalType of REQUEST_QUOTE
  upgradeData: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  canViewNewSeats: PropTypes.bool
};
export default AdminOnlyWrapper;